import axios from 'axios';

const debug = window.location.hostname === 'localhost';

export default axios.create({
	baseURL: (debug ? 'https:' : '') + `${CONFIG.api}`
});
